import React from "react"
import GeoreferenceContainer from "../components/Georeference/GeoreferenceContainer"

function GeoreferencePage() {
  return <GeoreferenceContainer />
}

export default GeoreferencePage
